import ApiGateway from "../api.gateway";

class AuthenticationError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const GatewayService = {
  login: async function (username, password) {
    const requestData = {
      username,
      password,
    };
    try {
      const response = await ApiGateway.post("/gateway/auth/sign", requestData);
      return response.data;
    } catch (error) {
      throw new AuthenticationError(401, error.message);
    }
  },
  me: async function (token) {
    try {
      const response = await ApiGateway.get("/gateway/auth/verify?token=" + token);
      return response.data;
    } catch (error) {
      console.log('error', error)
      throw new AuthenticationError(401, error.message);
    }
  },
};

export default GatewayService;

export { AuthenticationError, GatewayService };

